import { Gem, NotebookPen, Sparkles } from "lucide-react";

import { buildShopForCodes } from "@/lib/karma/shop";
import { cn } from "@/lib/utils";
import { Card } from "@/components/ui/card";

const ICONS = {
  Meditasyon: Sparkles,
  "Doğal taş": Gem,
  Olumlama: Sparkles,
  Ritüel: Sparkles,
  "Günlük çalışma": NotebookPen,
} as const;

export function ShopBundles({
  codes,
  className,
}: {
  codes: number[];
  className?: string;
}) {
  const bundles = buildShopForCodes(codes);

  return (
    <div className={cn("space-y-4", className)}>
      {bundles.map((bundle) => (
        <Card key={`${bundle.code}-${bundle.headline}`} className="p-4">
          <div className="font-display text-base font-semibold tracking-tight">
            {bundle.code === 0 ? "Kişisel Denge" : `Karmik Kod ${bundle.code}`}
          </div>
          <div className="mt-1 text-sm text-muted-foreground">
            {bundle.headline}
          </div>

          <div className="mt-4 grid gap-3 sm:grid-cols-2">
            {bundle.items.map((item) => {
              const Icon = ICONS[item.category] ?? Sparkles;
              return (
                <div
                  key={`${bundle.code}-${item.title}`}
                  className="rounded-xl border bg-muted/30 p-3"
                >
                  <div className="flex items-start gap-2">
                    <Icon className="mt-0.5 h-4 w-4 text-primary" />
                    <div className="min-w-0">
                      <div className="text-sm font-medium">{item.title}</div>
                      <div className="text-xs text-muted-foreground">
                        {item.category}
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 text-sm text-muted-foreground">
                    {item.description}
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
      ))}
    </div>
  );
}
